export const FirearmMotivationTypeConstants = {
    MYSELF: '7d339e44-7af9-478e-ac9d-2351b89d026c',
    SOMEONE_ELSE: '0b50b184-aaf0-4a6c-8266-6f1b6260f320'
}